import partial from "./partial.js";
import before from "./before.js";
export default partial(before, 2);
